import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import "./Timer.css";

const Timer = ({ seconds = 0 }) => {

  const formatTime = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        backgroundColor: '#f5f5f5',
        borderRadius: 5,
        padding: '4px 8px',
        border: '1px solid #e0e0e0',
      }}
      className="timer-container"
    >
      <AccessTimeIcon 
        sx={{ 
          fontSize: "1em", 
          color: '#666',
        }} 
      />
      <Typography
        sx={{
          fontSize: "1em",
          fontWeight: 500,
          color: '#333',
          letterSpacing: '0.02em',
        }}
      >
        {formatTime(seconds)}
      </Typography>
    </Box>
  );
};

export default Timer;
